<template>
  <div id="content-wrap" class="content-wrapper">
    <section class="content">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <va-box theme="box-primary" :title="title">
          <div slot="content">
            <div class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorProductName ? 'has-error' : ''">
              <label>Tên sản phẩm<span class="error-symbol"></span></label>
              <input type="text" class="form-control" v-model="product.name"
                     placeholder="Nhập tên sản phẩm ..."/>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12">
              <label>Mô tả sản phẩm</label>
              <input type="text" class="form-control" v-model="product.description"
                     placeholder="Mô tả sản phẩm ..."/>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorPrice ? 'has-error' : ''">
              <label>Giá sản phẩm (vnđ)</label>
              <currency-input v-model.number="product.price"
                     placeholder="Nhập giá sản phẩm ..."/>
            </div>
            <div class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorPaymentMethod ? 'has-error' : ''">
              <label>Phương thức thanh toán<span class="error-symbol"></span></label>
              <multiselect
                v-model="selectedPaymentMethod"
                id="ajax2"
                label="name"
                track-by="code"
                open-direction="bottom"
                :options="paymentMethods"
                :multiple="false"
                :searchable="false"
                :internal-search="false"
                :clear-on-select="false"
                :close-on-select="true"
                :options-limit="300"
                :limit="2"
                :max-height="600"
                :show-no-results="false"
                :hide-selected="false"
                :allow-empty="false"
                :show-labels="false"
              >
              </multiselect>
            </div>
            <div v-if="isCredit()" class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorPeriodFee ? 'has-error' : ''">
              <label>Phí thanh toán hàng tháng</label>
              <currency-input v-model.number="product.period_fee"
                     placeholder="Nhập phí thanh toán hàng tháng ..."/>
            </div>
            <div v-if="isCredit()" class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorDateInMonthPayment ? 'has-error' : ''">
              <label>Ngày thanh toán hàng tháng</label>
              <input type="number" class="form-control" v-model.number="product.date_in_month_payment"
                     placeholder="Nhập ngày thanh toán hàng tháng ..."/>
            </div>
            <div v-if="isCredit()" class="form-group col-md-12 col-sm-12 col-xs-12" v-bind:class="errorNumberOfDateNotify ? 'has-error' : ''">
              <label>Số ngày thông báo trước đến hạn thanh toán</label>
              <input type="number" class="form-control" v-model.number="product.number_of_date_notify"
                     placeholder="Nhập số ngày thông báo trước đến hạn thanh toán ..."/>
            </div>
          </div>
          <div slot="footer">
            <div class="pull-right">
              <b-button variant="success" class="w-100px" @click="save" :disabled="!isEditable">Lưu</b-button>
              <b-button variant="warning" class="w-100px" @click="back">Trờ về</b-button>
            </div>
          </div>
        </va-box>
      </div>
    </section>
  </div>
</template>

<script>
import VABox from 'va/widgets/VABox.vue'
import ProductAPI from '../../../api/product'
import Utils from '../../../common/utils'
import Multiselect from '../../../lib/vue-multiple-select/Multiselect'
import CompanyAPI from '../../../api/company'
import {debounce, isNumber} from 'lodash'
import {mapGetters} from 'vuex'
import {PAYMENT_METHOD, PAYMENT_METHOD_KEY, PERMISSION_KEY} from '../../../common/constant'

export default {
  name: 'ProductDetail',
  components: {
    'va-box': VABox,
    Multiselect
  },
  data () {
    return {
      product: {
        name: '',
        description: '',
        price: 0,
        payment_method: '',
        period_fee: 0,
        date_in_month_payment: 1,
        number_of_date_notify: 0,
        company_id: 0
      },
      selectedPaymentMethod: null,
      paymentMethods: [],
      loading: false,
      saving: false,
      selectedCompany: null,
      companies: [],
      loadingCompany: false,
      click: false,
      debounceCompany: null,
      disableCompanyField: false,
      isEditable: true,
      title: ''
    }
  },
  created () {
    this.debounceCompany = debounce(this.filterCompany.bind(this), 500)
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'editPermission'
    ]),
    errorCompany () {
      return this.click && this.selectedCompany == null
    },
    errorPaymentMethod () {
      return this.click && this.selectedPaymentMethod == null
    },
    errorProductName () {
      return this.isEmpty(this.product.name)
    },
    errorPrice () {
      return !isNumber(this.product.price)
    },
    errorPeriodFee () {
      return !this.isCredit() || !isNumber(this.product.period_fee)
    },
    errorDateInMonthPayment () {
      return !this.isCredit() || !(isNumber(this.product.date_in_month_payment) && this.product.date_in_month_payment >= 1 && this.product.date_in_month_payment <= 31)
    },
    errorNumberOfDateNotify () {
      return !this.isCredit() || !(isNumber(this.product.number_of_date_notify) && this.product.number_of_date_notify >= 0)
    }
  },
  mounted () {
    this.initCompany()
    this.initPaymentMethod()
    this.init()
    this.isEditable = this.hasEditPermission()
    this.title = this.isEdit() ? 'Cập nhật sản phẩm' : 'Thêm sản phẩm mới'
  },
  methods: {
    initCompany () {
      let company = Utils.getCompanyByUserInfo(this.userInfo)
      if (company) {
        this.disableCompanyField = true
        this.selectedCompany = {name: company.name, code: company.id}
      }
    },
    initPaymentMethod () {
      this.paymentMethods = Object.keys(PAYMENT_METHOD).map(
        key => { return {'name': PAYMENT_METHOD[key], 'code': key} }
      )

      this.selectedPaymentMethod = {'name': PAYMENT_METHOD[PAYMENT_METHOD_KEY.DEBIT], 'code': PAYMENT_METHOD_KEY.DEBIT}
    },
    isEdit () {
      return !!this.$route.params.id
    },
    hasEditPermission () {
      return Utils.isAdminUser(this.userInfo) || this.editPermission.includes(PERMISSION_KEY.PRODUCT_AND_WAREHOUSE)
    },
    isEmpty (value) {
      return (this.click && (value == null || value.length <= 0))
    },
    isCredit () {
      return this.selectedPaymentMethod && this.selectedPaymentMethod.code === PAYMENT_METHOD_KEY.CREDIT
    },
    init () {
      this.getProductDetail()
    },
    async getProductDetail () {
      this.loading = true
      const id = this.$route.params.id
      if (id) {
        try {
          this.product = (await ProductAPI.findById(id)).data.data
          this.selectedCompany = {
            code: this.product.company_id,
            name: this.product.company_name
          }
          this.selectedPaymentMethod = {'name': PAYMENT_METHOD[this.product.payment_method], 'code': this.product.payment_method}
          this.loading = false
        } catch (err) {
          this.loading = false
          Utils.handleError(this.$bvToast, err)
        }
      }
      return null
    },
    back () {
      this.$router.push({name: 'ProductList'})
    },
    filterCompany (query) {
      this.loadingCompany = true
      CompanyAPI.findByName(query, 0, 20).then(res => {
        this.companies = res.data.data.records.map(item => {
          return {'name': item.name, 'code': item.id}
        })
        this.loadingCompany = false
      }).catch(err => {
        Utils.handleError(this.$bvToast, err)
        this.loadingCompany = false
      })
    },
    validate () {
      if (this.selectedPaymentMethod.code === 'DEBIT') {
        return !this.errorCompany && !this.errorProductName && !this.errorPaymentMethod
      }
      return !this.errorCompany && !this.errorProductName && !this.errorPaymentMethod && !this.errorPrice && !this.errorPeriodFee && !this.errorDateInMonthPayment && !this.errorNumberOfDateNotify
    },
    save () {
      this.click = true
      this.saving = true
      this.loading = true
      if (!this.validate()) {
        this.saving = false
        this.loading = false
        return
      }

      const id = this.$route.params.id
      if (id) {
        this.product.company_id = this.selectedCompany.code
        this.product.payment_method = this.selectedPaymentMethod.code
        ProductAPI.update(this.product).then(res => {
          this.saving = false
          this.loading = false
          if (res != null && res.data != null) {
            Utils.successToast(this.$bvToast)
          }
        }).catch(err => {
          Utils.handleError(this.$bvToast, err)
        })
      } else {
        this.product.company_id = this.selectedCompany.code
        this.product.payment_method = this.selectedPaymentMethod.code
        ProductAPI.create(this.product).then(res => {
          this.saving = false
          this.loading = false
          if (res != null && res.data != null) {
            Utils.successToast(this.$bvToast)
            this.back()
          }
        }).catch(err => {
          Utils.handleError(this.$bvToast, err)
        })
      }
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/product/product/ProductDetail.vue